import { api } from './api'
import { Assessment, AssessmentFormData, AssessmentFilters } from '../types/assessment'

export const assessmentService = {
  /**
   * Get all assessments for a patient
   */
  getAll: async (patientId: string, filters?: AssessmentFilters): Promise<Assessment[]> => {
    const params = { patientId, ...filters }
    const response = await api.get<Assessment[]>(`/patients/${patientId}/assessments`, { params })
    return response.data
  },

  /**
   * Get a single assessment by ID
   */
  getById: async (id: string): Promise<Assessment> => {
    const response = await api.get<Assessment>(`/assessments/${id}`)
    return response.data
  },

  /**
   * Create a new assessment
   */
  create: async (data: AssessmentFormData): Promise<Assessment> => {
    const response = await api.post<Assessment>(`/patients/${data.patientId}/assessments`, data)
    return response.data
  },

  /**
   * Update an existing assessment
   */
  update: async (id: string, data: Partial<AssessmentFormData>): Promise<Assessment> => {
    const response = await api.put<Assessment>(`/assessments/${id}`, data)
    return response.data
  },

  /**
   * Delete an assessment
   */
  delete: async (id: string): Promise<void> => {
    await api.delete(`/assessments/${id}`)
  },
}
